import { store } from '@src/state/store';
import { handleNewChat } from '@src/state/slices/slice_game';
import { handleNewChat as handleNewChatToRoom } from '@src/state/slices/slice_app';

export default () => (data: any) => {
  if (
    (!data.gameId && !data.room) ||
    !data.message ||
    !data.playerName ||
    !data.playerId
  )
    return;

  // if chat is to a room, handle it and return early
  if (data.room) {
    store.dispatch(
      handleNewChatToRoom({
        room: data.room,
        playerName: data.playerName,
        message: data.message,
        playerId: data.playerId,
      }),
    );
    return;
  }

  store.dispatch(
    handleNewChat({
      gameId: data.gameId,
      playerName: data.playerName,
      message: data.message,
      playerId: data.playerId,
    }),
  );
};
